<template>
  <el-dialog
    :visible.sync="WorkingHours"
    :before-close="resetForm"
    :title="hoursTitle"
    width="1080px"
  >
    <el-form
      ref="recordWorkingHours"
      :model="recordWorkingHours"
      :inline="true"
      label-width="100px"
      size="small"
    >
      <!-- :label="'序号' + index" -->
      <el-row v-for="(domain, index) in recordWorkingHours.domains" :key="index+'a'">
        <!-- <el-form-item :label="index+1" label-width="150px"/> -->
        <span>{{index+1}}</span>
        <el-form-item
          :prop="'domains.' + index + '.tt_coding_start_date'"
          :rules="[{
                required: true, message: '日期不能为空', trigger: 'blur'
              }]"
          label="日期"
        >
          <el-date-picker
            @change="changeWorkingDate($event,domain,index)"
            @focus="datePickerFocus"
            :picker-options="pickerOptions"
            v-model="domain.tt_coding_start_date"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width:150px;"
          />
        </el-form-item>
        <el-form-item
          :prop="'domains.' + index + '.tt_coding_time'"
          :rules="[{
                required: true, message: '消耗工时不能为空', trigger: 'blur'
              }]"
          label="消耗工时"
        >
          <el-input-number :max="12" :min="0.1" :step="0.1" @blur="changeHours" @input.native="inputHours" v-model.number="domain.tt_coding_time" style="width:100px;"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="domain.tt_note" style="width:300px;"/>
        </el-form-item>
        <el-button @click.prevent="removeDomain(domain)">删除</el-button>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="addDomain">新增一行</el-button>
      <el-button type="primary" :disabled="disabledSaveWoringTimeBtn" :loading="saveLoading" @click="submitForm('recordWorkingHours')">保存</el-button>
      <el-button @click="resetForm('recordWorkingHours'),WorkingHours = false">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
// import Tinymce from '@/components/Tinymce'
import { hoursList } from '@/api/allTask'
import { debounce } from 'lodash'
export default {
  name: 'hoursDialog',
  props: ['visible', 'typeIds'],
  // components: { Tinymce },
  data() {
    return {
      recordWorkingHours: {
        domains: [
          {
            tt_coding_start_date: '',
            tt_coding_time: '',
            tt_note: ''
          }
        ]
      },
      WorkingHours: false,
      hoursTitle: '',
      formLabelWidth: '120px',
      disabledSaveWoringTimeBtn: false,
      saveLoading: false,
      pickerOptions: {}
    }
  },
  computed: {
    ...mapGetters(['userId', 'urlInfo'])
  },
  watch: {
    visible(val) {
      this.WorkingHours = val
      this.workingHoursDialog()
    }
  },
  created() {},
  methods: {
    workingHoursDialog(taskId, typeId) {
      if (this.typeIds === 1) {
        this.hoursTitle = '记录测试工时'
      }
      if (this.typeIds === 0) {
        this.hoursTitle = '记录开发工时'
      }
      this.recordWorkingHours.domains = [
        {
          tt_coding_start_date: '',
          tt_coding_time: '',
          tt_note: ''
        }
      ]
    },
    removeDomain(item) {
      var index = this.recordWorkingHours.domains.indexOf(item)
      if (index !== -1) {
        this.recordWorkingHours.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.recordWorkingHours.domains.push({
        tt_coding_start_date: '',
        tt_coding_time: '',
        tt_note: ''
      })
    },
    resetForm(formName) {
      this.$emit('resetForm')
      // this.$refs[formName].resetFields();
    },
    closeLoading() {
      this.saveLoading = false
    },
    submitForm(params) {
      // this.loading = true
      const submitObj = {
        user_id: this.userId,
        tt_type: this.typeIds, // 0开发 1测试 必填
        task_id: this.$route.query.task_id,
        task_tims: 1,
        tt_coding_start_date: [],
        tt_coding_time: [],
        tt_note: []
      }
      for (const i of this.recordWorkingHours.domains) {
        // console.log('list',i)
        submitObj.tt_coding_start_date.push(i.tt_coding_start_date)
        submitObj.tt_coding_time.push(i.tt_coding_time)
        submitObj.tt_note.push(i.tt_note)
      }
      this.$refs.recordWorkingHours.validate(valid => {
        if (valid) {
          this.saveLoading = true
          // console.log("结果", submitObj);
          this.$emit('submitForm', submitObj)
          this.WorkingHours = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async changeWorkingDate(val,currentRow,index){
      // 工时列表 判断是否有重复的日期
      try {
        const { data } = await hoursList(this.$route.query.task_id, this.typeIds)
        const dates = data && data.length ? data.map(item => item.tt_coding_start_date) : []
        if (dates.includes(val)) {
          this.$message.error('同一个任务在同一天只允许记录一次工时，如果工时有误，请在编辑工时处修改')
          this.disabledSaveWoringTimeBtn = true
        } else {
          this.disabledSaveWoringTimeBtn = false
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeHours(val) {
      // 超过12 或者小于0，提示 一天工时不允许超过12小时
      if (this.inputHourValue > 12 || this.inputHourValue < 0) {
        this.$message({
          type: 'warning',
          message: '一天工时不允许超过12小时和小于1小时'
        })
      }
    },
    inputHours(val){
      this.inputHourValue = val.target.value
    },
    datePickerFocus(){
       // 判断已填的数据是否有重复
      const hasDates = this.recordWorkingHours.domains.map(item => item.tt_coding_start_date)
      this.pickerOptions.disabledDate = (time) => {
        // 排除已经填过的日期, 小于10 补0
        return hasDates.includes(
          `${time.getFullYear()}-${time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1}-${time.getDate() < 10 ? '0' + time.getDate() : time.getDate()}`
        )
      }
    }
  }
}
</script>
<style scope>
</style>
